import html2canvas from "../libs/html2canvas"
import QRCode from "qrcode"

/**
 * 获取分享的快照
 * @param id
 * @returns {Promise<string | never>}
 */
export function generateScreenShots(id) {
  let shareContent = document.querySelector("#" + id) //需要截图的包裹的（原生的）DOM 对象
  let width = shareContent.offsetWidth //获取dom 宽度
  let height = shareContent.offsetHeight //获取dom 高度

  let canvas = document.createElement("canvas") //创建一个canvas节点
  let content = canvas.getContext("2d") //获取context,设置scale

  let scale = window.devicePixelRatio //定义任意放大倍数 支持小数
  canvas.width = width * scale //定义canvas 宽度 * 缩放
  canvas.height = height * scale //定义canvas高度 *缩放

  canvas.getContext("2d").scale(scale, scale)

  let rect = shareContent.getBoundingClientRect() //获取元素相对于视察的偏移量
  content.translate(-rect.left, -rect.top) //设置context位置，值为相对于视窗的偏移量负值，让图片复位

  let opts = {
    scale: scale, // 添加的scale 参数
    canvas: canvas, //自定义 canvas
    // logging: true, //日志开关，便于查看html2canvas的内部执行流程
    width: width, //dom 原始宽度
    height: height,
    backgroundColor: null,
    useCORS: true // 【重要】开启跨域配置
  }

  return html2canvas(shareContent, opts).then(function (canvas) {
    let context = canvas.getContext("2d")
    // 【重要】关闭抗锯齿
    context.mozImageSmoothingEnabled = false
    context.webkitImageSmoothingEnabled = false
    context.msImageSmoothingEnabled = false
    context.imageSmoothingEnabled = false

    return canvas.toDataURL("image/png")
  })
}

/**
 * 获取分享的二维码
 * @param url
 * @param success
 * @param fail
 */
export function generateQRCode({ url, success, fail }) {
  QRCode.toDataURL(
    url,
    {
      margin: 1
    },
    function (err, dataUrl) {
      if (!err) {
        // 证明生成了二维码（canvas） 然后把二维码转为图片
        success(dataUrl)
      } else {
        fail(err)
      }
    }
  )
}

/**
 * 将图片转换成base64类型的
 * @param url
 * @param callback
 * @param outputFormat
 */
export function toBase64(url, callback, outputFormat) {
  let canvas = document.createElement("canvas")
  let ctx = canvas.getContext("2d")
  let img = new Image()

  img.crossOrigin = "Anonymous"
  img.onload = function () {
    canvas.height = img.height
    canvas.width = img.width

    ctx.drawImage(img, 0, 0)

    let dataUrl = canvas.toDataURL(outputFormat || "image/png")

    callback.call(this, dataUrl)
  }

  img.src = url
}

export function getUrlQRCode(shareUrl) {
  return new Promise((resolve, reject) => {
    generateQRCode({
      url: shareUrl,
      success: url => {
        resolve(url)
      },
      fail: err => {
        reject(err)
      }
    })
  })
}

export function getBase64(url, outputFormat = "image/png", catchError = false) {
  // 如果地址是http地址，则转为base64，如果已经是base64则无需转换
  return new Promise((resolve, reject) => {
    if (url.indexOf("base64") > -1) {
      resolve(url)
    } else {
      try {
        let canvas = document.createElement("canvas"),
          ctx = canvas.getContext("2d"),
          img = new Image()

        img.crossOrigin = "Anonymous"
        img.onload = () => {
          canvas.height = img.height
          canvas.width = img.width
          ctx?.drawImage(img, 0, 0)
          let dataURL = canvas.toDataURL(outputFormat)
          canvas = null
          resolve(dataURL)
        }
        img.onerror = error => {
          catchError ? reject(error) : resolve(error)
        }

        img.src = `${url}?t=${+new Date()}`
      } catch (error) {
        catchError ? reject(error) : resolve(error)
      }
    }
  })
}

// h5传参给小程序 用于分享自定义图片
export function onShareAppMessage(path = "", currentItem = "") {
  let imageUrl = ""
  let minishareImg = currentItem?.serviceZoneMaterial?.minishareImg
  if (path.indexOf("order") > -1) {
    imageUrl = minishareImg ? `https:${minishareImg}` : ""
  }
  // eslint-disable-next-line no-undef
  wx.miniProgram.postMessage({ data: { imageUrl } })
}
